import { ProductType } from "../models/ProductType"
import axios from "../api/axios"
import { PRODUCTS_URL } from "../utils/constants"

export async function productsService(): Promise<ProductType[]> {
  const response = await axios.get(PRODUCTS_URL)
  return response.data
}
